/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_New_Group_Name_LabelInputs */

const en_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Group Name`)
};

const fr_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom du nouveau groupe`)
};

const de_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Gruppenname`)
};

const it_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo nome del gruppo`)
};

const ru_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новое название группы`)
};

const es_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo nombre del grupo`)
};

const zh_cn2_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新组名`)
};

const ja_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいグループ名`)
};

const hi_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए समूह का नाम`)
};

const pt_pt2_marker_import_new_group_name_label = /** @type {(inputs: Marker_Import_New_Group_Name_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo nome do grupo`)
};

/**
* | output |
* | --- |
* | "New Group Name" |
*
* @param {Marker_Import_New_Group_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_new_group_name_label = /** @type {((inputs?: Marker_Import_New_Group_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_New_Group_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_new_group_name_label(inputs)
	if (locale === "de") return de_marker_import_new_group_name_label(inputs)
	if (locale === "it") return it_marker_import_new_group_name_label(inputs)
	if (locale === "ru") return ru_marker_import_new_group_name_label(inputs)
	if (locale === "es") return es_marker_import_new_group_name_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_new_group_name_label(inputs)
	if (locale === "ja") return ja_marker_import_new_group_name_label(inputs)
	if (locale === "hi") return hi_marker_import_new_group_name_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_new_group_name_label(inputs)
	return en_marker_import_new_group_name_label(inputs)
});